import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

// Formats a 24-hour "HH:MM" time string (as stored/returned by the API) into
// 12-hour display format, e.g. "09:00" -> "9:00 AM", "15:30" -> "3:30 PM".
export function formatTime12h(time24) {
  if (!time24) return time24;
  const [hourStr, minute] = time24.split(":");
  const hour = parseInt(hourStr, 10);
  if (Number.isNaN(hour)) return time24;
  const period = hour >= 12 ? "PM" : "AM";
  const hour12 = hour % 12 === 0 ? 12 : hour % 12;
  return `${hour12}:${minute} ${period}`;
}
